import * as React from "react";
import { useReducer, useEffect } from "react";
import { Row, Col, Button, Input, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import GenericDropdown from './controls/GenericDropdown';
import { LookupItem } from "../Models/LookupItem";
import * as Utils from '../Utils';
import CheckboxList from "./controls/CheckboxList";

type OrderBy = 'date' | 'alpha';

type SavingsBenefitsListingRedirectProps = {
    Categories: LookupItem[];
    Locations: LookupItem[];
    Organizations: LookupItem[];
    Tags: LookupItem[];
    SavingsBenefits: LookupItem[];
    BackgroundImage: string;
    Title: string;
    ListingUrl: string;
}

type SavingsBenefitsListingRedirectState = {
    keywords: string;
    selectedCategories: LookupItem[];
    selectedLocations: LookupItem[];
    selectedOrganizations: LookupItem[];
    selectedTags: LookupItem[];
    selectedSavingsBenefits: LookupItem;
    redirectUrl: string;
}

const buildInitialState = (props: SavingsBenefitsListingRedirectProps) => {

    let initialState: SavingsBenefitsListingRedirectState = {
        keywords: '',
        selectedCategories: [],
        selectedLocations: props.Locations,
        selectedOrganizations: [],
        selectedTags: [],
        selectedSavingsBenefits: (props.SavingsBenefits || []).length > 0 ? props.SavingsBenefits[0] : undefined,
        redirectUrl: ''
    }

    return initialState;
}

const SavingsBenefitsListingRedirect = (props: SavingsBenefitsListingRedirectProps) => {

    const [state, setState] = useReducer(
        (prevState: SavingsBenefitsListingRedirectState,
            SavingsBenefitsstate: Partial<SavingsBenefitsListingRedirectState>) => ({ ...prevState, ...SavingsBenefitsstate }),
        buildInitialState(props)
    );

    const search = () => {

        const filter = getHashParams();

        window.location.href = state.selectedSavingsBenefits.Value + Utils.buildHash(filter);
    };

    const getHashParams = () => {

        const filter: HashParams = {
            cat: state.selectedCategories.map(x => x.Title).join('|'),
            loc: state.selectedLocations.map(x => x.Title).join('|'),
            org: state.selectedOrganizations.map(x => x.Title).join('|'),
            tag: state.selectedTags.map(x => x.Title).join('|'),
            q: state.keywords
        };

        return filter;
    }

    useEffect(() => {
        const filter = getHashParams();

        setState({ redirectUrl: props.ListingUrl + Utils.buildHash(filter) });

    }, [state.keywords,
        state.selectedCategories,
        state.selectedLocations,
        state.selectedOrganizations,
        state.selectedTags,
    ]);

    // return
    return <div className="chapters-listing">
        <div className="chapter-filters-wrapper" style={{ backgroundImage: `url(${props.BackgroundImage})` }}>
            <h1 className="title">{props.Title}</h1>
            <div className="saving-benefits inline-filters d-flex flex-md-row flex-column flex-sm-column">
                <div className="d-md-flex w-100">

                    <UncontrolledDropdown>
                        <DropdownToggle caret>
                            All Categories
                        </DropdownToggle>
                        <DropdownMenu>
                            <CheckboxList
                                dataSource={props.Categories}
                                getId={x => x.Value}
                                renderItem={x => x.Title}
                                selectedValues={state.selectedCategories.map(x => x.Value) || []}
                                onSelectedItemChanged={(item, checked) => {

                                    let updatedValues = [];

                                    if (checked) {
                                        updatedValues = state.selectedCategories.concat([item]);
                                    } else {
                                        updatedValues = state.selectedCategories.filter(x => x.Value != item.Value);
                                    }

                                    setState({ selectedCategories: updatedValues });
                                }}
                            />
                        </DropdownMenu>
                    </UncontrolledDropdown >
                    <UncontrolledDropdown>
                        <DropdownToggle caret>
                            All Locations
                        </DropdownToggle>
                        <DropdownMenu>
                            <CheckboxList
                                dataSource={props.Locations}
                                getId={x => x.Value}
                                renderItem={x => x.Title}
                                selectedValues={state.selectedLocations.map(x => x.Value) || []}
                                onSelectedItemChanged={(item, checked) => {

                                    let updatedValues = [];

                                    if (checked) {
                                        updatedValues = state.selectedLocations.concat([item]);
                                    } else {
                                        updatedValues = state.selectedLocations.filter(x => x.Value != item.Value);
                                    }

                                    setState({ selectedLocations: updatedValues });
                                }}
                            />
                        </DropdownMenu>
                    </UncontrolledDropdown >
                    <UncontrolledDropdown>
                        <DropdownToggle caret>
                            All Organizations
                        </DropdownToggle>
                        <DropdownMenu>
                            <CheckboxList
                                dataSource={props.Organizations}
                                getId={x => x.Value}
                                renderItem={x => x.Title}
                                selectedValues={state.selectedOrganizations.map(x => x.Value) || []}
                                onSelectedItemChanged={(item, checked) => {

                                    let updatedValues = [];

                                    if (checked) {
                                        updatedValues = state.selectedOrganizations.concat([item]);
                                    } else {
                                        updatedValues = state.selectedOrganizations.filter(x => x.Value != item.Value);
                                    }

                                    setState({ selectedOrganizations: updatedValues });
                                }}
                            />
                        </DropdownMenu>
                    </UncontrolledDropdown >

                    <UncontrolledDropdown>
                        <DropdownToggle caret>
                            All Collections
                        </DropdownToggle>
                        <DropdownMenu>
                            <CheckboxList
                                dataSource={props.Tags}
                                getId={x => x.Value}
                                renderItem={x => x.Title}
                                selectedValues={state.selectedTags.map(x => x.Value) || []}
                                onSelectedItemChanged={(item, checked) => {

                                    let updatedValues = [];

                                    if (checked) {
                                        updatedValues = state.selectedTags.concat([item]);
                                    } else {
                                        updatedValues = state.selectedTags.filter(x => x.Value != item.Value);
                                    }

                                    setState({ selectedTags: updatedValues });
                                }}
                            />
                        </DropdownMenu>
                    </UncontrolledDropdown >

                    <div className="search" style={{ maxWidth: "45%" }}>
                        <form className="form-inline search-form">
                            <div className="input-group w-100">
                                <div className="search-icon">
                                    <i className="fas fa-search"></i>
                                </div>
                                <Input onChange={(e) => { setState({ keywords: e.target.value }) }}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            search();
                                        }
                                    }}
                                    value={state.keywords}
                                    className="form-control"
                                    placeholder="Search for keywords and description" />

                                <Button onClick={search}>Search</Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

}

export class HashParams {
    cat: string;
    loc: string;
    org: string;
    tag: string;
    q: string;
}


export default SavingsBenefitsListingRedirect;